import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { cn } from '@marvelapp/ballpark-components';
export const CardSortingSidebar = observer(function CardSortingSidebar(props) {
    const { className } = props, rest = __rest(props, ["className"]);
    return (_jsx("aside", Object.assign({ className: cn('p-4', 'max-h-full', 'overflow-auto', 'w-[calc(50%+8px)]', 'xl:w-[calc(33%+16px)]', '2xl:w-[calc(25%+16px)]', className) }, rest)));
});
